import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DialogConfig } from '../dialog/dialog-config';
import { DialogRef } from '../dialog/dialog-ref';
import { UiEngineComponent } from '../ui-engine/ui-engine.component';
//this component extends ui engine for plotting grid and implement search
@Component({
    selector: 'app-advance-search',
    templateUrl: '../ui-engine/ui-engine.component.html',
    styleUrls: ['../ui-engine/ui-engine.component.scss'],
    standalone: false
})
export class AdvanceSearchComponent extends UiEngineComponent implements OnInit {

  constructor(public injector: Injector,
    public router: Router,
    public route: ActivatedRoute,
    public modal: BsModalService,
    public config: DialogConfig,
    public dialog: DialogRef
  ) {
    super(injector, router, route, modal);
  }
  //overiding ngonit as we don't need to go that deep for advance search
  ngOnInit() {
    let question = this.config != undefined && this.config.data != undefined && this.config.data.question ? this.config.data.question : false;
    if (!this.parent_id) {
      this.parent_id = 0;
    }
    this.initCurrentData();
    if (this.config.data != undefined && this.config.data.resource != undefined) {
      this._currentData.resource = this.config.data.resource;
      this._currentData.json = this._currentData.resource;
    }

    this.baseService.getResourceDef(this._currentData.json, (resouceDef) => {
      if (resouceDef) {
        this.showPopUp = true;//for not changing page title
        //deleting and modifying as per advance search
        if (resouceDef.capability != undefined) {
          delete resouceDef.capability;
        }
        if(this.config.data.capability){
          resouceDef.capability = this.config.data.capability;
        }
        if(this.config.data.bulkAction){
          resouceDef.list.bulkAction = this.config.data.bulkAction;
        }
        this._currentData.dataGridConfig = {};
        if (this.config.data.datasource != undefined && this.config.data.datasource) {
          resouceDef.list['APIresource'] = {};
          resouceDef.list['APIresource']['datasource'] = this.config.data.datasource != undefined && this.config.data.datasource ? this.config.data.datasource : "";
          this._currentData.gridData['args'] = resouceDef.list['APIresource']['datasource'].args != undefined ? resouceDef.list['APIresource']['datasource'].args : "";
        }
        if (this.config.data.datasource && this.config.data.datasource.searchColumns) {
          this._currentData.gridData['searchColumns'] = this.config.data.datasource.searchColumns;
          // this._currentData.dataGridConfig['advance_searchColumns'] = this.config.data.datasource.searchColumns;
        }
        if (this.config.data.datasource && this.config.data.datasource.search_columns) {
          this._currentData.gridData['search_columns'] = this.config.data.datasource.search_columns
          // this._currentData.dataGridConfig['advance_search_columns'] = this.config.data.datasource.search_columns;
        }
        if (this.config.data.datasource && this.config.data.datasource.search) {
          this._currentData.gridData['search'] = this.config.data.datasource.search;
          // this._currentData.dataGridConfig['advance_search'] = this.config.data.datasource.search;
        }
        // advance search 
        
        if (question && resouceDef.list != undefined && resouceDef.list['filter'] != undefined && question.defaultsetting != undefined && question.defaultsetting.advancesearch != undefined && question.defaultsetting.advancesearch.hideFilter != undefined && question.defaultsetting.advancesearch.hideFilter) {
          delete resouceDef.list['filter'];
        }
        resouceDef.list['rowClick'] = true;
        this._currentData.currentResource = resouceDef.resource;
        this._layout = 'simple';
        this._layout_data = resouceDef;
        this.showGridOnly = true;
        this.initLayoutData();
      }
      else if (!resouceDef && this._currentData.json == "defaultAdvSearch") {
        resouceDef = {};
        resouceDef.list = {};
        resouceDef.list['APIresource'] = {};
        resouceDef.list['APIresource']['datasource'] = this.config.data.datasource != undefined && this.config.data.datasource ? this.config.data.datasource : "";
        this._currentData.gridData['args'] = resouceDef.list['APIresource']['datasource'].args != undefined ? resouceDef.list['APIresource']['datasource'].args : "";
        this._currentData.gridData['filter'] = resouceDef.list['APIresource']['datasource'].filter != undefined ? resouceDef.list['APIresource']['datasource'].filter : "";
        if (question && question.defaultsetting != undefined && question.defaultsetting.singleSelection) {
          resouceDef.list['rowClick'] = true;
        }
        this._currentData.currentResource = "defaultAdvSearch";
        this._layout = 'simple';
        this._layout_data = {
          "resource": "account",
          "list": {
            'rowClick': true,
            "fields": [
              {
                "heading": "Values",
                "order": 2,
                "sortable": true,
                "name": this.config.data.question.getterValue
              }
            ]
          }
        };

        this.showGridOnly = true;
        this.initLayoutData();
      }
      //this will work for multiple selection
      if (question && question.defaultsetting != undefined && question.defaultsetting.singleSelection === false) {
        this._layout_data.list["bulkAction"] = {
          "key": question.getterKey,
          "actions": [
            {
              "action": "external_event",
              "label": "Select",
              "icon": "fa-plus-square",
              "form": false
            }
          ]
        }
        if (question.defaultsetting.limitSelection) {
          this._layout_data.list["bulkAction"].actions[0].allow_selection = question.defaultsetting.limitSelection;
        }
        this._currentData.bulkAction = this._layout_data.list["bulkAction"];
      }
    });
  }
  //sending the obj to be filled
  buttonAction(menuObj) {

    this.loader.hideSpinner();

    if ( menuObj.actionType && typeof menuObj.actionType === 'object' && menuObj.actionType.enableActionOnAdvanceSearch &&menuObj.actionType.action) {
      super.buttonAction(menuObj);
    }
    else if (menuObj.data != undefined) {
      event.stopPropagation();    // for preventing to close advance search selecteion
      this.dialog.close(menuObj.data);
    }
    else {
      super.buttonAction(menuObj);
    }
  }

  bindGrid(resource?, application?, type?, queryId?, printInfo?, callback = null) {
    if (this.config.data.datasource != undefined) {
      let datasource = this.config.data.datasource;
      resource = datasource.resource;
      application = datasource.application;
      queryId = datasource.query_id;
      if(this.config.data.datasource.page_size != undefined && this._currentData != undefined && this._currentData.gridData != undefined && !this._currentData.gridData['limit_change']){
        this._currentData.gridData.page_size = this.config.data.datasource.page_size;
      }
      if(this.config.data.datasource.projectionKeys){
        this._currentData.gridData.projectionKeys = this.config.data.datasource.projectionKeys;
      }
    }
    if (resource == undefined)
      resource = this._currentData.currentResource;


    if (this.config.data != undefined && this.config.data.datasource != undefined && this.config.data.datasource.search_columns != undefined && this.config.data.datasource.search_columns) {
      this._currentData.gridData['search_columns'] = this.config.data.datasource.search_columns;
    }



    super.bindGrid(resource, application, type, queryId, printInfo,()=>{
      let question = this.config != undefined && this.config.data != undefined && this.config.data.question ? this.config.data.question : false;
      var key = (this._currentData.bulkAction != undefined && this._currentData.bulkAction.key != undefined)?this._currentData.bulkAction.key:(question.getterKey != undefined)?question.getterKey:"text";
      
      if(this._currentData.selectedItems != undefined && this._currentData.selectedItems.length>0){
        for (let index = 0; index < this._currentData.selectedItems.length; index++) {
          const element = this._currentData.selectedItems[index];
          if(element[key] == undefined){
            element[key]=element['id']
          }          
        }
      }
    })
  }

  initLayoutData(action?: any): void {
    this._currentData.selectedItems = this.config['dropDownSelecteditems'] != undefined && this.config['dropDownSelecteditems'].length > 0 ? this.config['dropDownSelecteditems'] :[];
    super.initLayoutData(action)
  }

  onBulkActionClicked(event) {
    this.loader.hideSpinner();

    let totalSelecteitems = this.config['dropDownSelecteditems'] && this.config['dropDownSelecteditems'].length != undefined && this.config['dropDownSelecteditems'].length > 0 ?event.items.length : event.items.length;
    if (this.config.data.question!=undefined && this.config.data.question.defaultsetting!=undefined && this.config.data.question.defaultsetting.limitSelection != undefined && this.config.data.question.defaultsetting.limitSelection < totalSelecteitems) {
      this.alerts.error(`You are allowed to select upto  ${this.config.data.question.defaultsetting.limitSelection} Service Item`)
      return
    }
 else if (event.items != undefined && event.action != undefined && event.action.action != undefined && event.action.action == 'external_event') {
  if(document.getElementById('ui_defaultAdvSearch') != null){
      document.getElementById('ui_defaultAdvSearch').addEventListener("click", function(e){
        e.stopPropagation();
      });
    }
      this.dialog.close(event.items);
    } else
      super.onBulkActionClicked(event)
  }

  getDataForCrudOperationFn(resouceDef) {
    super.getDataForCrudOperationFn(resouceDef);
    this._currentData.dataGridConfig.customButtonsAllowed = false;
    this._currentData.dataGridConfig.insidePopup = true;
    if (this._currentData.config.tile != undefined && this._currentData.config.tile) {
      this._currentData.config.tile = false;
      this._currentData.dataGridConfig.tile = false;
      this._currentData.config.activeField = 'table';
      this._currentData.dataGridConfig.activeField = 'table';
    }
    this._currentData.dataGridConfig.not_found_text = 'type_to_search';
  }

  getFilter() {
    //this._currentData.gridData['filter'] = '';
    if (this._layout == 'tab') {
      if (this._layout_data[this._layout_id]['data']['filter']) {
        this._currentData.gridData['filter'] = this._layout_data[this._layout_id]['data']['filter'];
      } else {
        this.checkFilterConditions();
      }
    } else if (this.filter != undefined) {
      this._currentData.gridData['filter'] = this.filter;
    } else {
      this.checkFilterConditions();
    }
  }

}
